/**
 * 電子契約 認可コード発行 
 */
 import Vue from 'vue'
 import * as httpConst from '../../../constants/httpConst'
 
 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/contract_authorize`
 
 const contract_authorize = {
   namespaced: true,
   actions: {
    create( { commit, state } ) {
      return new Promise( ( resolve, _reject) => {
        Vue.$http.post(API_PATH).then( data => {
          let content = data
          resolve(content)
        } )
      })
    },
   },
 }
 
 export default contract_authorize
 
 